import React, { useEffect,useState } from "react";
import { Transition } from "react-transition-group";

const FadeBotton = (props) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    loader();// eslint-disable-next-line
  }, [props.open]);
  const loader = () => {
    if (props.type === "sticky") {
      setOpen(
        props.open === true
          ? open === true
            ? true
            : true
          : open === true
          ? true
          : false
      );
    } else {
      setOpen(props.open);
    }
  };
  const duration = props.duration < 0 ? props.duration : 1500;

  // El desplazamiento va por transform y no por padding-top: el padding cambia
  // la altura del documento, y al aparecer todas las secciones la pagina se
  // encoge miles de pixeles y el scroll queda apuntando a una zona vacia.
  const oculto = `translateY(${props.paddingTop || 0}px)`;

  const defaultStyle = {
    transition: `opacity ${duration}ms cubic-bezier(0.31, 0.89, 0.76, 1.07),transform ${duration}ms cubic-bezier(0.31, 0.89, 0.76, 1.07)`,
    opacity: 0,
    transform: oculto,
  };

  const transitionStyles = {
    entering: { opacity: 1, transform: "translateY(0px)" },
    entered: { opacity: 1, transform: "translateY(0px)" },
    exiting: { opacity: 0, transform: oculto },
    exited: { opacity: 0, transform: oculto },
  };
  return (
    <Transition in={open} timeout={duration}>
      {(state) => (
        <div
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {props.children}
        </div>
      )}
    </Transition>
  );
};

export default FadeBotton;
